import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ErrorMessage } from "@hookform/error-message";
import { Controller, useFormContext } from "react-hook-form";

// react-datepicker throws (blank screen) unless `selected` is a Date or null.
// Programmatic setValue — e.g. the Encompass prefill — can hand it a string,
// so coerce defensively here rather than trusting every caller.
const asDate = (v) => {
    if (!v) return null;
    if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
    if (typeof v === "string") {
        const us = v.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);       // MM/DD/YYYY
        if (us) return new Date(+us[3], +us[1] - 1, +us[2]);
        const iso = v.match(/^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})$/);      // YYYY/MM/DD
        if (iso) return new Date(+iso[1], +iso[2] - 1, +iso[3]);
        const d = new Date(v);
        return isNaN(d.getTime()) ? null : d;
    }
    return null;
};

const DateField = ({ field_id, field_label, field_placeholder, field_value, validation }) => {
    const { register, errors, control } = useFormContext();
    const startDate = new Date();

    return (
        <div className="mb-3">
            <label htmlFor={field_id} className="form-label">{field_label}</label>
            <Controller
                control={control}
                name={field_id}
                valueName="selected" // DateSelect value's name is selected
                onChange={([selected]) => selected}
                defaultValue={startDate}
                render={({ field }) => (
                    <DatePicker
                        {...register(field_id)}
                        dateFormat={validation ? JSON.parse(validation).format : ""}
                        onChange={(date) => field.onChange(date)}
                        selected={asDate(field.value) || startDate}
                        yearDropdownItemNumber={100}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        showMonthDropdown
                        ref={{ current: {} }}
                        className="form-control" />
                )}
                rules={{ required: "This field is required" }}
            />
            <ErrorMessage
                errors={errors}
                name={field_id}
                render={({ message }) => <p className="fb-error-message">{message}</p>}
            />
        </div>
    )
}

export default DateField